"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _getNativeProps = _interopRequireDefault(require("../../../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FieldRequired = function FieldRequired(_ref) {
  var props = _extends({}, _ref);

  return _react.default.createElement("abbr", _extends({
    className: "co--required",
    title: "Required"
  }, (0, _getNativeProps.default)(props)), "*");
};

FieldRequired.displayName = 'Form.Required';
var _default = FieldRequired;
exports.default = _default;
FieldRequired.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Form.Required"
};